import { useState } from "react";
import { INIT_LOADING_REQUEST, DEFAULT_MESSAGE } from "../constants";

const useLoadingRequest = () => {
	const [loadingRequest, setLoadingRequest] = useState({
		...INIT_LOADING_REQUEST,
	});
	const hide = () => {
		setLoadingRequest(prev => ({
			...prev,
			hidden: true,
		}));
	};
	const show = (message = DEFAULT_MESSAGE) => {
		setLoadingRequest({
			hidden: false,
			message: message,
		});
	};
	return {
		value: loadingRequest,
		hide,
		show
	};
};

export default useLoadingRequest;
